export function trackClick(event, name, elementType) {
  window.oneTag.track('link', {
    event_name: 'ui_interaction',
    ui_interaction_action: 'click',
    ui_interaction_element_id: event.currentTarget.id,
    ui_interaction_element_name: name,
    ui_interaction_element_type: elementType,
  });
}

export function trackClickWithDescription(
  name,
  elementType,
  elementDescription
) {
  window.oneTag.track('link', {
    event_name: 'ui_interaction',
    ui_interaction_action: 'click',
    ui_interaction_element_name: name,
    ui_interaction_element_type: elementType,
    ui_interaction_element_description: elementDescription,
  });
}

export function trackPageView(page_title) {
  window.oneTag.track('view', {
    event_name: 'page_view',
    page_title: `${page_title}`,
  });
}

export function trackErrorPageView(errorObj) {
  const errorElementName = errorObj.errorTitle
    ? `${errorObj.errorTitle} : ${errorObj.errorMessage}`
    : errorObj.errorMessage;

  const errorEvent = {
    event_name: 'general_error',
    page_title: 'error',
    ui_interaction_element_type: errorObj.value,
    ui_interaction_element_name: errorElementName,
  };
  window.oneTag.track('view', errorEvent);
  console.debug(`Error : ${JSON.stringify(errorEvent)}`);
}

export function trackPageImpression(name, elementType, elementDescription) {
  window.oneTag.track('link', {
    event_name: 'page_impression',
    ui_interaction_action: 'impression',
    ui_interaction_element_name: name,
    ui_interaction_element_type: elementType,
    ui_interaction_element_description: elementDescription,
  });
}

export function trackSiteSearch(searchTerm, searchCategory, searchFilters) {
  window.oneTag.track('link', {
    event_name: 'site_search',
    search_term: searchTerm,
    search_category: searchCategory,
    site_search_filters: searchFilters,
    site_search_total_results: '',
  });
}
